<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Local Service Bulletin - Mobile (Other Language) Edit</h2>
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Local Service Bulletin
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile (Other Language) Edit
            </div>
            <!-- <skp-breadcrumbs @page-title="val => (pageTitle = val)" /> -->
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            Date
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="edit.REG_DT"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>
                            Register
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    v-model="edit.REG_USER_ID"
                                    readonly
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>
                            <select
                                disabled
                                class="slt_white w100p"
                                v-model="edit.TYPE1"
                                @change="edit.TYPE2 = ''"
                            >
                                <option value="Guide">Guide</option>
                                <option value="Bulletin">Bulletin</option>
                            </select>
                        </td>
                        <th>Subtype</th>
                        <td>
                            <select
                                class="slt_white w100p"
                                ref="TYPE2G"
                                disabled
                                v-if="edit.TYPE1 === 'Guide'"
                                v-model="edit.TYPE2_G"
                                v-validation
                            >
                                <option value>Select Inquiry type</option>
                                <option value="Common">Common</option>
                                <option value="IMEI">IMEI</option>
                                <option value="Policy / Process">Policy / Process</option>
                                <option value="SW Tool">SW Tool</option>
                                <option value="Jig / Equipment">Jig / Equipment</option>
                                <option value="Training Material">Training Material</option>
                            </select>

                            <select
                                class="slt_white w100p"
                                ref="TYPE2B"
                                disabled
                                v-if="edit.TYPE1 === 'Bulletin'"
                                v-model="edit.TYPE2_B"
                                v-validation
                            >
                                <option value>Select Inquiry type</option>
                                <option
                                    v-for="item in bulletinType2List"
                                    :key="item"
                                    :value="item"
                                >{{item}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Urgency
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="N" v-model="edit.URGENCY_YN" disabled />
                                <i class="radio-icon"></i>
                                <em>Normal</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="Y" v-model="edit.URGENCY_YN" disabled />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Urgency</em>
                            </label>
                        </td>
                        <th>
                            Need Translation
                        </th>
                        <td>
                            <label class="radiobox-wrap mr10">
                                <input type="radio" name value="Y" v-model="edit.NEED_REPROCESS" disabled />
                                <i class="radio-icon"></i>
                                <em class="txt_red">Need</em>
                            </label>
                            <label class="radiobox-wrap">
                                <input type="radio" name value="N" v-model="edit.NEED_REPROCESS" disabled />
                                <i class="radio-icon"></i>
                                <em>Not Need</em>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Title
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    ref="title"
                                    minlength="5"
                                    maxlength="200"
                                    v-model="edit.TITLE"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    minlength="2"
                                    maxlength="200"
                                    disabled
                                    v-model="edit.TAG_INFO"
                                    value
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            User Level
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <!--User Levec heckbox-->
                            <!--checkbox_all-->
                            <div class="check_wrap w260p">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxUserLevelAll"
                                        :checked="checkedUserLevelList.length === allUserLevelList.length"
                                        @change="onUserLevelAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div
                                class="check_wrap w260p"
                                v-for="item in userLevelList"
                                :key="item.CODE_ID"
                            >
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        :value="item.CODE_ID"
                                        v-model="checkedUserLevelList"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>{{item.CODE_ID}}({{item.CODE_NAME}})</em>
                            </div>
                            <!--//User Level checkbox-->
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Subsidary
                            <em class="txt_mandatory">*</em>
                            <span class="ico_pen" @click="selectSubsidiaryPopup">pen아이콘</span>
                        </th>
                        <td colspan="3">
                            <ul class="ul_list">
                                <li
                                    class="userlevel_txt"
                                    v-for="item in selectedSubsidiaryList"
                                    :key="item"
                                >{{item}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Country
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3" class="userlevel">
                            <div
                                v-if="availableCountryList.length === 0"
                            >
                                Please select subsidiary first.
                            </div>
                            <div class="check_wrap w260p" v-if="availableCountryList.length > 0">
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        ref="checkboxCountryAll"
                                        :checked="checkedCountryList.length === availableCountryList.length"
                                        @change="onCountryAllCheckboxChange($event)"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>All</em>
                            </div>
                            <div
                                class="check_wrap w260p"
                                v-for="item in availableCountryList"
                                :key="item.CODE_ID"
                            >
                                <label class="checkbox-wrap mr5">
                                    <input
                                        type="checkbox"
                                        :value="item.CDCODE"
                                        v-model="checkedCountryList"
                                    />
                                    <i class="check-icon"></i>
                                </label>
                                <em>{{item.CDDESC}}</em>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Contents
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td colspan="3">
                            <cross-editor
                                editorId="bulletin"
                                :editorData="edit.CONTENT" />
                        </td>
                    </tr>
                    <!-- <tr>
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                            <innorix-upload
                                :id="getUploadId"
                                :name="getUploadId" 
                                :uploadId="getUploadId"
                                :onlyUpload="onlyUpload"
                                :attachList="attachFileSeq"
                                @files="setAttachFiles"
                            />
                        </td>
                    </tr> -->
                    <tr v-for="language in translationLanguages" :key="language">
                        <th>Attachment ({{language}})</th>
                        <td colspan="3" class="no_padding" >
                            <div v-if="toTranslateList.includes(language) && !isLoading[language]">
                                <innorix-upload
                                    :id="language"
                                    :name="language" 
                                    :uploadId="language"
                                    serviceType="hhpsvc"
                                    :onlyUpload="false"
                                    :attachList="fileList[language]"
                                    @files="setAttachFiles"
                                />
                            </div>
                            <span v-else-if="toTranslateList.includes(language) && isLoading[language]">
                                Loading...
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a
                    href="javascript:"
                    class="btn_white"
                    @click="$router.push({name: 'hhpServiceBulletinOtherView', query: {seq}})"
                >View</a>
                <div class="btn_right">
                    <a href="javascript:" class="btn_blue" @click="onSaveClick()">Save</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue            from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';

// import { EventBus } from '@/utils/EventBus';

import KnowledgeTargetPopup from '~vb/knowledge/popup/KnowledgeTargetPopup';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

export default {
    name: '',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
    },
    props: {
        seq: {
            type: String | Number,
            reqruied: true,
        },
    },
    computed: {
        getGuid() {
            if (SDLUtil.isNull(this.guid)) {
                this.guid = StringUtil.guid();
            }
            return this.guid;
        },
        getEditorId() {
            if (SDLUtil.isNull(this.editorId)) {
                this.editorId = 'ce_' + this.getGuid;
            }
            return this.editorId;
        },
        getUploadId() {
            if (SDLUtil.isNull(this.uploadId)) {
                this.uploadId = 'inno_' + this.getGuid;
            }
            return this.uploadId;
        },
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            allUserLevelList: [],

            userLevelList: [],
            subsidiaryList: [],
            bulletinType2List: [],

            selectedSubsidiaryList: [],

            edit: {
                REG_DT: '',
                REG_USER_ID: '',
                URGENCY_YN: 'N',
                NEED_REPROCESS: 'Y',
                TYPE1: 'Guide',
                TYPE2: '',
                TYPE2_B: '',
                TYPE2_G: '',
                CONTENT: '',
                TITLE: '',
                TAG_INFO: '',
            },
            checkedUserLevelList: [],

            availableCountryList: [],
            checkedCountryList: [],

            guid: '', // 임의의 guid
            editorId: '', // CE id
            uploadId: '', // Innorix id
            onlyUpload: false, // Innorix upload only check

            fileList: {
                Spanish: [],
                French: [],
                German: [],
                Russian: [],
            },

            attachFilesByLanguage: {
                Spanish: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                French: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                German: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                Russian: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
            },

            // attachFileSeq: [], // Attach files
            // delAttachFiles: [], // Delete attach files
            // isRemove: false, // Attach remove flag

            isLoading: {
                Spanish: true,
                French: true,
                German: true,
                Russian: true,
            },

            toTranslateList: [],
            translationLanguages: ['Spanish', 'French', 'German', 'Russian'],
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);

            this.edit.REG_USER_ID = SDLUtil.getLoginedUserInfo().loginId;

            const dateFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            this.edit.REG_DT = moment().formatWithJDF(dateFormat);

            const data = await this.fetchInitData();
            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Initial Loading Error',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }

            console.log('Init data', data);

            this.setInitData(data);

            this.lazyLoadInnorix();

            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            const params = {
                seq: this.seq,
            };

            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbOtherModify.skp`, { params })
                    .then(res => {
                        console.log('SvcBulletin RESPONSE', res);
                        console.log('SvcBulletin RESPONSE DATA', res.data);
                        // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
                        // console.log('LOG', this.availableParentCodeList);
                        return res.data;
                    })
                // .catch(err => {
                //     console.log(`SvcBulletin ERROR =>>`, err);
                //     return res.data;
                // })
            );
        },
        setInitData(data) {
            this.bulletinType2List = data.bulletinType2List.map(item => item.TYPE2);

            this.userLevelList = data.userLevelLabelList;
            this.allUserLevelList = data.userLevelLabelList.map(item => item.CODE_ID);
            this.checkedUserLevelList = data.userLevelList.map(item => item.USER_LEVEL);

            this.subsidiaryList = data.subsidiaryList;
            this.selectedSubsidiaryList =
                data.selectedSubsidiaryList
                    .map(c => {
                        return data.subsidiaryList
                            .find(s => {
                                return c.CORP_NO === s.SUBSIDIARY_CD;
                            }).SUBSIDIARY_NM;
                    })
                    ;

            this.fetchAvailableCountryList()
                .then(d => {
                    this.availableCountryList = d.countryList;
                });

            this.checkedCountryList = data.country.map(c => c.COUNTRY_CD);

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            // console.log('userLevelList', this.userLevelList);

            const {
                title,
                reg_dt,
                reg_user_id,
                udt_dt,
                udt_user_id,
                need_reprocess,
                type1,
                type2,
                urgency_yn,
                content,
                tag_info,
            } = data.view;

            this.edit = {
                TITLE: title,
                CONTENT: SDLUtil.stripHtml(content),
                REG_DT: reg_dt,
                REG_USER_ID: reg_user_id,
                UDT_DT: udt_dt,
                UDT_USER_ID: udt_user_id,
                NEED_REPROCESS: need_reprocess,
                TYPE1: type1,
                TYPE2: type2,
                TYPE2_G: type1 === 'Guide' ? type2 : '',
                TYPE2_B: type1 === 'Bulletin' ? type2 : '',
                URGENCY_YN: urgency_yn,
                TAG_INFO: tag_info,
                TRAN: '',
            };

            this.toTranslateList = data.view.tran
                .split(',')
                .filter(item => item)
                .map(item => item.replace(/ /g, ''));

            this.encToken = data.encToken;

            const convertFileList = (item) => {
                item.ENC_ATTCH_FILE_SEQ = item.ATTCH_FILE_SEQ;
                item.ENC_TOKEN = data.encToken;
                return item;
            };

            this.fileList.Spanish = data.fileListES.map(convertFileList);
            this.fileList.French = data.fileListFR.map(convertFileList);
            this.fileList.German = data.fileListDE.map(convertFileList);
            this.fileList.Russian = data.fileListRU.map(convertFileList);

            // this.attachFilesByLanguage.Spanish = data.fileListES;
            // this.attachFilesByLanguage.French = data.fileListFR;
            // this.attachFilesByLanguage.German = data.fileListDE;
            // this.attachFilesByLanguage.Russian = data.fileListRU;

            // this.fileList = data.fileList;
            // this.attachFileSeq = data.fileList;
            console.log('attachFilesByLanguage', this.attachFilesByLanguage);
        },

        lazyLoadInnorix() {
            let delay = 100;

            this.toTranslateList.forEach(language => {
                window.setTimeout(() => {
                    this.isLoading[language] = false;
                    // EventBus.$emit('innorix-reset-file-list', language);
                }, delay += 100);
            });
        },

        fetchAvailableCountryList() {
            const subsidiary = this.selectedSubsidiaryList
                .map(name => {
                    return this.subsidiaryList.find(item => item.SUBSIDIARY_NM === name).SUBSIDIARY_CD;
                })
                .join(',');

            const params = { subsidiary };
            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/notice/countryBySubsidiary.skp`, { params })
                .then(res => res.data)
                .catch(err => err.data);
        },

        onSaveClick() {
            this.save();
        },

        async save() {
            if (!this.validateInput()) return;

            const formData = this.prepFormData();
            // console.log('formData', formData);

            const data = await SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbOtherModifyProc.skp', formData);

            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Error while Saving!',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }

            if (data.result) {
                SDLUtil.alert({
                    title: 'Success!',
                    msg: data.message,
                    onOkEvt: () => {
                        this.$router.push({
                            name: 'hhpServiceBulletinOtherView',
                            query: {
                                seq: this.seq,
                            },
                        });
                    },
                });
            }
        },

        mergeFileList() {
            let merged = [
                ...this.attachFilesByLanguage['Spanish'].attachFileSeq,
                ...this.attachFilesByLanguage['French'].attachFileSeq,
                ...this.attachFilesByLanguage['German'].attachFileSeq,
                ...this.attachFilesByLanguage['Russian'].attachFileSeq,
            ].map(item => item.attachFileSeq);
            return merged;
        },

        validateInput() {
            if (!this.edit.TYPE2) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a subtype.',
                    onOkEvt: () => {
                        if (this.edit.TYPE1 === 'Guide') {
                            this.$refs.TYPE2G.focus();
                        } else {
                            this.$refs.TYPE2B.focus();
                        }
                    },
                });
                return false;
            }

            if (!this.edit.TITLE.trim() || this.edit.TITLE.length < 5) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Title is required.',
                    onOkEvt: () => this.$refs.title.focus(),
                });
                return false;
            }

            if (this.checkedUserLevelList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 user level needs to be selected.',
                });
                return false;
            }

            if (this.checkedCountryList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'At least 1 country needs to be selected.',
                });
                return false;
            }
            return true;
        },

        prepFormData() {
            console.log('subList', this.selectedSubsidiaryList);
            const countryCodeList = this.selectedSubsidiaryList;

            const CEblankTxt = '<p><br></p>';
            const content = window.bulletin.GetBodyValue();
            if (content === CEblankTxt) {
                //invalid
            }

            const params = {
                seq: this.seq,
                TITLE: this.edit.TITLE,
                TYPE1: this.edit.TYPE1,
                TYPE2: this.edit.TYPE1 === 'Guide' ? this.edit.TYPE2_G : this.edit.TYPE2_B,
                TAG_INFO: this.edit.TAG_INFO,
                URGENCY_YN: this.edit.URGENCY_YN,
                REG_USER_ID: this.edit.REG_USER_ID,
                REG_DT: this.edit.REG_DT,
                // SUBSIDIARY: this.edit.,
                COUNTRY_VALUE_SPLIT: this.checkedCountryList.join(','),
                COUNTRY_TEXT_SPLIT: this.checkedCountryList
                    .map(code => this.availableCountryList.find(country => country.CDCODE === code).CDDESC)
                    .join(','),
                USER_LEVEL_SPLIT: this.checkedUserLevelList.join(','),
                NEED_REPROCESS: this.edit.NEED_REPROCESS,
                CONTENT: content,

                attachFileSeq: this.mergeFileList(),

                attFileSeq : this.attachFilesByLanguage['Spanish'].attachFileSeq.map(item => '1'+item.attachFileSeq),
                attFileSeq2: this.attachFilesByLanguage['French'].attachFileSeq.map(item => '2'+item.attachFileSeq),
                attFileSeq3: this.attachFilesByLanguage['German'].attachFileSeq.map(item => '3'+item.attachFileSeq),
                attFileSeq4: this.attachFilesByLanguage['Russian'].attachFileSeq.map(item => '4'+item.attachFileSeq),
            };
            return params;
        },

        submit(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbOtherModifyProc.skp', formData)
                .then(res => {
                    console.log('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        selectSubsidiaryPopup() {
            SDLUtil.show(
                KnowledgeTargetPopup,
                {
                    selTargetList: this.selectedSubsidiaryList,
                    rtnFunc: this.onSelectSubsidiaryList,
                },
                { height: 'auto' },
            );
        },

        async onSelectSubsidiaryList(list = []) {
            // Subsidiary Target popup 에서 받아온 리스트를 sort 하여 답는다.
            this.selectedSubsidiaryList = list.sort();
            const data = await this.fetchAvailableCountryList();
            this.availableCountryList = data.countryList;
            console.log('countryList', this.availableCountryList);
        },

        onUserLevelAllCheckboxChange(e) {
            console.log('change e', e);
            this.checkedUserLevelList = e.target.checked ? this.allUserLevelList : [];
        },
        onCountryAllCheckboxChange(e) {
            console.log('change e', e);
            this.checkedCountryList = e.target.checked ? this.availableCountryList.map(item => item.CDCODE) : [];
        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixUpload.vue -> BulletinOtherEdit.vue / files : ', val);
            this.attachFilesByLanguage[val.uploadId] = {
                attachFileSeq : val.fileList || [],
                delAttachFiles : val.delFileList || [],
                isRemove : val.isRemove || false,
            };

            // this.attachFileSeq = val.fileList || [];
            // this.delAttachFiles = val.delFileList || [];
            // this.isRemove = val.isRemove || false;
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinOtherEdit.vue